import React from "react"

import { Box } from "components"

const Spacer = ({ minWidth, ...rest }) => (
  <Box
    data-component-id="gap"
    minWidth={[0, null, minWidth || 32]}
    minHeight={[16, 32, 0]}
    {...rest}
  />
)

export default Spacer
